
















import { Component, Prop, Vue } from 'vue-property-decorator';

import {
	countOnMonitoringLevel,
	monitoringLevelLabelKey,
	resolveMonitoringLevel,
} from '../../../core/monitoringLevel';
import { MmMonitoringLevel } from '../../../types/enums';
import { MmTaskFilters } from '../../../types/dto';

const KEY_TASK_FORM = 'priceMonitoring.mobileMonitoring.taskForm.';
const KEY_FILTERS = 'priceMonitoring.mobileMonitoring.filters.';

@Component
export default class MonitoringLevelHint extends Vue {
	/** Фильтры обязаны быть уже подготовлены: сырой сентинел «Все» посчитался бы как выбранная единица */
	@Prop({ required: true }) readonly filters!: MmTaskFilters;

	get monitoringLevel(): MmMonitoringLevel {
		return resolveMonitoringLevel(this.filters);
	}

	get unitsOnLevel(): number {
		return countOnMonitoringLevel(this.filters);
	}

	get levelLabel(): string {
		return this.$t(monitoringLevelLabelKey(this.monitoringLevel)) as string;
	}

	get summaryText(): string {
		return this.$t(KEY_FILTERS + 'monitoringLevelHint', {
			level: this.levelLabel,
			count: this.unitsOnLevel,
		}) as string;
	}

	get explanationText(): string {
		if (this.monitoringLevel === 'subcategory') {
			return this.$t(KEY_TASK_FORM + 'levelHintSubcategory') as string;
		}

		if (this.monitoringLevel === 'category') {
			return this.$t(KEY_TASK_FORM + 'levelHintCategory') as string;
		}

		return this.$t(KEY_TASK_FORM + 'levelHintGroup') as string;
	}

	/** Для подкатегории складываем группы и категории: поглощённый выбор показывается целиком */
	get ignoredUnitsCount(): number {
		const level = this.monitoringLevel;

		if (level === 'group') {
			return 0;
		}

		const groupsCount = this.lengthOf(this.filters.groups);

		if (level === 'category') {
			return groupsCount;
		}

		return groupsCount + this.lengthOf(this.filters.categories);
	}

	get isUpperLevelIgnored(): boolean {
		return this.ignoredUnitsCount > 0;
	}

	get ignoredText(): string {
		if (this.monitoringLevel === 'subcategory') {
			return this.$t(KEY_TASK_FORM + 'levelIgnoredGroupsCategories', {
				count: this.ignoredUnitsCount,
			}) as string;
		}

		return this.$t(KEY_TASK_FORM + 'levelIgnoredGroups', {
			count: this.ignoredUnitsCount,
		}) as string;
	}

	private lengthOf(list: number[]): number {
		return list && list.length ? list.length : 0;
	}
}
